import type { TripPlannerSurfaceActivityEntry } from 'tripPlanner/assistant/surfaceSnapshots/surfaceActivityEntryTypes'
import { boundActivityDisplayText } from 'tripPlanner/assistant/surfaceSnapshots/surfaceActivityDisplayText'
import { toAssistantSurfaceId } from 'tripPlanner/assistant/surfaceSnapshots/assistantSurfacePlainText'

// googlePlaceId in `fields`, not embedded in displayText -- gives the model a live pointer back
// to lookup_google_places for a drawer opened earlier in the turn, not just the name it was
// opened under.
//
// Normalized through toAssistantSurfaceId, not passed raw -- see
// buildOfferDrawerOpenedActivityEntry's identical note (same markdownUtils.tsx `place:` link
// origin, same svc-trip silent-drop-on-invalid-value risk, same reason a delimiter-collision
// argument alone doesn't cover it).
export function buildPlaceDrawerOpenedActivityEntry(
  placeName: string,
  sourcePath: string,
  googlePlaceId: string,
): TripPlannerSurfaceActivityEntry {
  const normalizedPlaceId = toAssistantSurfaceId(googlePlaceId)
  return {
    kind: 'place_drawer_opened',
    label: 'Opened place details',
    displayText: boundActivityDisplayText(`Opened details for "${placeName}"`),
    sourcePath,
    dataClassification: 'personalised_surface',
    occurredAt: new Date().toISOString(),
    ...(normalizedPlaceId !== undefined ? { fields: [{ key: 'placeId', value: normalizedPlaceId, dataClassification: 'personalised_surface' as const }] } : {}),
  }
}
